import { Action } from 'redux';
import { EventFamily } from '../entities';

export enum TFamily {
  SET_FAMILY = 'SET_FAMILY',
  SET_FAMILIES = 'SET_FAMILIES',
  FETCH_FAMILIES = 'FETCH_FAMILIES',
}

export interface ISetFamily extends Action {
  type: TFamily.SET_FAMILY;
  payload: EventFamily;
}
export const ASetFamily = (payload: EventFamily): ISetFamily => ({ type: TFamily.SET_FAMILY, payload });

export interface ISetFamilies extends Action {
  type: TFamily.SET_FAMILIES;
  payload: EventFamily[];
}
export const ASetFamilies = (payload: EventFamily[]): ISetFamilies => ({ type: TFamily.SET_FAMILIES, payload });

export interface IFetchFamilies extends Action {
  type: TFamily.FETCH_FAMILIES;
}
export const AFetchFamilies = (): IFetchFamilies => ({ type: TFamily.FETCH_FAMILIES });
